import { z } from "zod";
import { MODULE_KEYS } from "../modules.js";
import { ROLES } from "../roles.js";
import { emailSchema } from "./auth.js";
import { optionalText } from "./common.js";

export const tenantUpdateSchema = z.object({
  name: z.string().trim().min(2).max(120),
  locale: z.enum(["it", "en"]).default("it"),
  currency: z.string().length(3).default("EUR"),
});

export const inviteMemberSchema = z.object({
  email: emailSchema,
  role: z.enum(ROLES).exclude(["owner"]),
  /** progetti a cui l'invitato accede subito (obbligatori per i clienti) */
  projectIds: z.array(z.string().uuid()).max(50).default([]),
});
export const inviteClientSchema = z.object({
  projectId: z.string().uuid(),
  email: emailSchema,
});
export const updateMemberSchema = z.object({
  userId: z.string().uuid(),
  role: z.enum(ROLES).exclude(["owner"]),
});

export const moduleToggleSchema = z.object({ key: z.enum(MODULE_KEYS), enabled: z.boolean() });
export const moduleSettingsSchema = z.object({ key: z.enum(MODULE_KEYS), settings: z.record(z.string(), z.unknown()) });

export const profileUpdateSchema = z.object({
  firstName: z.string().trim().min(1).max(80),
  lastName: z.string().trim().min(1).max(80),
  locale: z.enum(["it", "en"]).default("it"),
});
export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1).max(200),
  newPassword: z.string().min(10).max(200),
});

export const notificationListSchema = z.object({
  unreadOnly: z.boolean().default(false),
  limit: z.number().int().min(1).max(100).default(30),
});

export const favoriteInputSchema = z.object({
  module: z.enum(MODULE_KEYS),
  entityType: z.string().min(1).max(40),
  entityId: z.string().uuid(),
  label: z.string().trim().min(1).max(120),
});

export const searchSchema = z.object({ q: z.string().trim().min(1).max(200), limit: z.number().int().min(1).max(50).default(20) });
export const searchHitSchema = z.object({
  module: z.string(),
  type: z.string(),
  id: z.string(),
  title: z.string(),
  subtitle: z.string().nullable(),
  link: z.string(),
});
export type SearchHit = z.infer<typeof searchHitSchema>;

export const entityNoteSchema = z.object({
  entityType: z.enum(["company", "contact", "deal", "project", "task"]),
  entityId: z.string().uuid(),
  body: z.string().trim().min(1).max(20_000),
});

export const checkoutSchema = z.object({ interval: z.enum(["month", "year"]).default("month") });

export const billingProfileShortSchema = z.object({
  companyName: z.string().trim().min(2).max(200),
  vatNumber: optionalText(30),
  sdiCode: optionalText(7),
  pec: optionalText(200),
});
